export const inputClassname = 'text-dark text-[14px] leading-[20px]'
export const wrapperClassName = '!rounded-[12px] !py-[4px] !min-h-[44px]'
export const placeholderClassname = '!top-[9.5px] leading-[16px] text-[12px]'
